import React from 'react';
import { useTranslation } from 'react-i18next';
import { CheckCircle2 } from 'lucide-react';
import { BD } from '../bookDemoTheme';

interface SuccessStepProps {
  /** ISO-8601 start of the booked meeting. */
  startTime: string;
  email: string;
  onReturn: () => void;
}

const SuccessStep: React.FC<SuccessStepProps> = ({ startTime, email, onReturn }) => {
  const { t, i18n } = useTranslation();

  const meeting = new Date(startTime);
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const when = meeting.toLocaleString(i18n.language, {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    hour: '2-digit',
    minute: '2-digit',
  });

  return (
    <div className="flex flex-1 flex-col items-center justify-center px-5 pb-16 text-center">
      <CheckCircle2 size={120} strokeWidth={1.2} className={`mb-6 ${BD.accentText}`} />

      <h1
        className={`text-[26px] sm:text-[42px] font-bold tracking-[-0.01rem] leading-9 sm:leading-[59px] mb-3 ${BD.textPrimary}`}
      >
        {t('bookDemo.success.title')}
      </h1>
      <p className={`text-[18px] sm:text-[22px] leading-7 font-semibold mb-3 ${BD.accentText}`}>
        {when} ({timezone})
      </p>
      <p
        className={`text-[14px] sm:text-[16px] leading-5 sm:leading-6 font-normal max-w-[640px] mx-auto mb-6 sm:mb-10 ${BD.textSecondary}`}
      >
        {t('bookDemo.success.confirmation', { email })}
      </p>

      <button
        type="button"
        onClick={onReturn}
        className={`h-11 px-[30px] rounded-xl text-[16px] leading-6 font-semibold ${BD.accentBgDeep} ${BD.textOnAccent}`}
      >
        {t('bookDemo.success.returnHome')}
      </button>
    </div>
  );
};

export default SuccessStep;
